import React, { } from 'react'
import { PIIContent, ShowMore } from '../dashboard.styled'
import { Modal, Statistic } from 'antd'
import ChartHeader from './ChartHeader'

function PII (props) {
  const { data, settingMode } = props
  const { UISetting, content = {} } = data || {}
  const { pii = [] } = UISetting
  const contentMapping = content?.data?.reduce((all, i) => ({ ...all, [i.label]: i.value }), {})

  const handleShowMore = (value, title) => {
    Modal.info({
      title,
      content: value?.join(', ')
    })
  }
  const formatContent = (value, title) => Array.isArray(value)
    ? <span>
        {value[0]}
        {value.length > 1 ? <ShowMore onClick={() => handleShowMore(value, title)}>[...]</ShowMore> : ''}
      </span>
    : value

  return (
    <>
      <ChartHeader {...props} />
      <PIIContent>
        {pii?.sort((a, b) => a.sort - b.sort)?.map((i, idx) => {
          const column = Array.isArray(i.column) ? i.column[i.column.length - 1] : i.column
          const name = i.rename || column
          const title = Array.isArray(name) ? name[name.length - 1] : name
          return <Statistic key={idx} title={title} value={settingMode ? `${title} Data` : formatContent(contentMapping[column], i) || '-'} formatter={v => v} />
        })}
      </PIIContent>
    </>
  )
}

export default PII
